import { useEffect } from 'react'
import Head from 'next/head'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import keyboardOnlyOutlines from '@moxy/keyboard-only-outlines'

import { APP_NAME } from '@/constants'
import useAuth from '@/hooks/useAuth'
import useSessionTimeoutTracker from '@/hooks/useSessionTimeoutTracker'
import '@/utils/rollbar'
import 'styles/main.scss'

const App = dynamic(() => import('@/components/App'), { ssr: false })

export default function MyApp({ Component, pageProps }) {
  const router = useRouter()
  const { isAuthorized, isAuthReady } = useAuth()

  useSessionTimeoutTracker()

  useEffect(() => {
    const fn = keyboardOnlyOutlines()

    const boldText = 'font-weight: bold'
    const normalText = 'font-weight: normal'
    // eslint-disable-next-line no-console
    console.log(`%cWelcome to ${APP_NAME}!
    \n%cRelease Date: %c${process.env.releaseDate}
    \n%cTag: %c${process.env.NEXT_PUBLIC_BUILD_TAG}
    \n%cEnvironment: %c${process.env.NEXT_PUBLIC_ENV}`,
    boldText,
    boldText, normalText,
    boldText, normalText,
    boldText, normalText)

    return fn
  }, [])

  return (
    <>
      <Head>
        <title>Neat | Payment Portal</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
      </Head>
      {isAuthReady && isAuthorized && (
        <App layoutProps={{ ...Component.layoutProps }}>
          {router.isReady && <Component {...pageProps} />}
        </App>
      )}
    </>
  )
}

MyApp.propTypes = {
  Component: PropTypes.func.isRequired,
  pageProps: PropTypes.shape({}).isRequired,
}
